import { FileIcon } from "components/design/FileIcon";
import ToolTip from "components/design/toolTip";
import { Preview } from "components/PreviewModal";
import { useModal } from "hooks/useModal";
import { ReactNode } from "react";
import { FileObject } from "types/Models/fileObject";

type FilePreviewCellProps = {
  file: Pick<FileObject, "name" | "uuid" | "file_type" | "is_previewable">;
  children?: ReactNode;
};

export const FilePreviewCell = ({ file, children }: FilePreviewCellProps) => {
  const { open, close, isOpen } = useModal();

  return (
    <>
      <div
        role="button"
        className="t-inline-flex t-items-center t-gap-2 t-w-full t-text-body-sm"
        onClick={open}
      >
        <ToolTip
          text={<div className="t-max-w-40 t-break-words">{file.name}</div>}
        >
          <div className="t-flex t-items-center t-gap-1 t-max-w-full">
            <FileIcon
              fileType={file.file_type}
              size="24"
              className="t-shrink-0"
            />
            <div className="t-flex-1 t-truncate t-text-body-sm t-text-text-60">
              {file.name}
            </div>
          </div>
        </ToolTip>
        {children}
      </div>
      <Preview showModal={isOpen} closeModal={close} previewId={file.uuid} />
    </>
  );
};
